"use client";
import React, { useCallback, useEffect, useState } from "react";

import {
  Modal,
  ModalBody,
  ModalCross,
  ModalHeading,
  ModalLayout,
  ModalOverflow,
} from "components/common/modal.styled";
import T from "@marginly/ui/components/typography";
import {
  ParticipantsCount,
  RatingItem,
  RatingNum,
  RatingTeamInfo,
  ReferrealBadge,
  YourRank,
} from "./leaderboard/styled";
import { formatNum } from "util/format";
import Space from "components/common/space";
import { LeaderboardReferrersList } from "types/api";

export const RefferalRankingModal = (props: {
  onHide?: () => void;
  address?: string;
  list: LeaderboardReferrersList | undefined;
  renderImgPath: (value: number) => string;
}) => {
  const [isModalHeaderColored, setIsModalHeaderColored] = useState(false);
  const [initialScroll, setInitialScroll] = useState(0);

  const handleHide = useCallback(() => {
    props.onHide?.();
  }, [props]);

  useEffect(() => {
    let scrollarea = document.getElementById("scollarea");
    let firstCildren = scrollarea?.firstElementChild;
    if (firstCildren) {
      setInitialScroll(firstCildren.getBoundingClientRect().top);
    }
  }, []);

  useEffect(() => {
    const handleScroll = (firstCildren) => {
      if (firstCildren.getBoundingClientRect().top <= initialScroll) {
        setIsModalHeaderColored(true);
      } else setIsModalHeaderColored(false);
    };

    let scrollarea = document.getElementById("scollarea");
    let firstCildren = scrollarea?.firstElementChild;
    if (firstCildren) {
      scrollarea?.addEventListener("scroll", () => {
        handleScroll(firstCildren);
      });
    }
  }, [initialScroll]);

  return (
    <>
      <Modal>
        <ModalLayout onClick={handleHide} />
        <ModalCross onClick={handleHide}>
          <img src="images/button-close.svg" alt="close" className="cross" />
          <img src="images/goback.svg" alt="close" className="arrow" />
        </ModalCross>
        <ModalBody className="sm" id="scollarea">
          <ModalHeading
            className={isModalHeaderColored ? "colored padded" : "padded"}
          >
            <div>
              <T headerL>Top 10 referrers</T>
              <Space height={4} heightMobile={4} />
              <T secondary body>
                From {formatNum(props.list?.total)}.
              </T>
            </div>
          </ModalHeading>

          <ModalOverflow className="padded" style={{ paddingTop: "0" }}>
            {props.list?.top?.slice(0, 10).map((item, key) => {
              return (
                <RatingItem key={key}>
                  <RatingNum className="referral">{key + 1}</RatingNum>
                  <RatingTeamInfo className="sm">
                    <div>
                      <span>
                        {".." +
                          item.userAddress.substring(
                            item.userAddress.length - 4,
                          )}
                      </span>
                      {props.address == item.userAddress ? (
                        <YourRank>Your rank</YourRank>
                      ) : (
                        <></>
                      )}
                    </div>
                  </RatingTeamInfo>
                  <ReferrealBadge>
                    <img src={props.renderImgPath(key + 1)} alt="" />
                  </ReferrealBadge>
                  {item.referralCount ? (
                    <ParticipantsCount className="referral">
                      {formatNum(item.referralCount)}&nbsp;
                      {item.referralCount > 1 ? "users" : "user"}
                    </ParticipantsCount>
                  ) : (
                    <div></div>
                  )}
                </RatingItem>
              );
            })}
          </ModalOverflow>
        </ModalBody>
      </Modal>
    </>
  );
};
